module.exports = __webpack_public_path__ + "media/wind.55f1a8c0.ogg";